module.exports = __webpack_public_path__ + "static/img/Slide-Serv-3.85e08bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-Serv-3.png
// module id = Olqj
// module chunks = 0